
import { images } from "../constants";

const courses = [
    {
        id: 1,
        image: images.course1,
        title: "Introduction to Artificial Intelligence",
        content: "Explore AI fundamentals and see how it's shaping modern technologies across industries.",
        details: {
            date: "18 January, 2025",
            duration: "3 Months",
            instructor: "John Doe",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "100 Enrolled",
            price: "$100",
        },
        overviews: [
            "Introduction to Artificial Intelligence is a foundational course aimed at providing a comprehensive overview of AI concepts. Students will explore core topics like intelligent agents, machine learning, neural networks, and ethical considerations in AI systems through interactive lessons and real-world examples."
        ],
        features: [
            "Fundamentals of AI and Intelligent Agents",
            "Basic Machine Learning Concepts",
            "Intro to Neural Networks",
            "Ethics and Safety in AI",
            "Mini AI Capstone Project"
        ],
        outcomes: [
            "Explain what Artificial Intelligence is and how it's applied",
            "Recognize the difference between supervised and unsupervised learning",
            "Understand the basics of how AI systems learn and make decisions",
            "Explore ethical implications and responsible AI practices",
            "Develop a basic AI-based solution"
        ],
        prerequisites: [
            "Basic programming knowledge (Python preferred)",
            "Logical thinking and analytical mindset",
            "High school-level math proficiency",
            "Interest in emerging technologies",
            "Willingness to participate in group activities and projects"
        ],
        curriculum: [
            {
                id: 1,
                heading: "What is AI?",
                content: "A high-level introduction to Artificial Intelligence, its types, history, and major applications."
            },
            {
                id: 2,
                heading: "Understanding Intelligent Agents",
                content: "Explore how AI agents perceive their environment and take action to achieve goals."
            },
            {
                id: 3,
                heading: "Machine Learning Basics",
                content: "An introduction to learning models and training algorithms in AI."
            },
            {
                id: 4,
                heading: "Introduction to Neural Networks",
                content: "Understand the building blocks of neural networks and their role in modern AI."
            },
            {
                id: 5,
                heading: "AI Ethics and Future Outlook",
                content: "Discuss the ethical impact of AI and its future in different industries."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course1Comment1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "An excellent introduction to AI! The hands-on projects helped me grasp key concepts effectively."
            },
            {
                id: 2,
                image: images.course1Comment2,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Great course! The explanations were clear, and the instructor provided great insights into AI applications."
            }
        ],
    },
    {
        id: 2,
        image: images.course2,
        title: "Computer Vision and Image Processing",
        content: "Learn how computers interpret and process visual data to enable intelligent image analysis.",
        details: {
            date: "25 February, 2025", 
            duration: "3 Months",
            instructor: "Jane Smith",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "85 Enrolled",
            price: "$120",
        },
        overviews: [
            "This course dives into the fundamentals of computer vision and image processing. Students will learn how to analyze, process, and extract meaningful information from digital images and video. Topics include image enhancement, object detection, edge detection, and feature extraction using practical tools and libraries like OpenCV and Python."
        ],
        features: [
            "Introduction to Computer Vision",
            "Image Filtering and Enhancement",
            "Edge Detection and Segmentation",
            "Feature Extraction and Object Recognition",
            "Real-Time Image Processing Projects"
        ],
        outcomes: [
            "Understand how machines interpret images and videos",
            "Apply filters and transformations to enhance images",
            "Implement edge and corner detection techniques",
            "Detect and recognize objects in real-world scenes",
            "Build practical computer vision applications"
        ],
        prerequisites: [
            "Basic knowledge of Python programming",
            "Understanding of basic mathematics and matrices",
            "Familiarity with NumPy and image arrays",
            "Interest in visual computing technologies",
            "Commitment to completing projects and assignments"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Introduction to Computer Vision",
                content: "Explore how machines perceive and understand visual data from the world."
            },
            {
                id: 2,
                heading: "Image Processing Fundamentals",
                content: "Learn about pixel operations, filtering, color models, and histogram equalization."
            },
            {
                id: 3,
                heading: "Feature Detection and Matching",
                content: "Understand how to identify and match key points in images."
            },
            {
                id: 4,
                heading: "Object Detection and Recognition",
                content: "Implement techniques to detect, track, and classify objects in images or video."
            },
            {
                id: 5,
                heading: "Building Real-Time Vision Applications",
                content: "Use OpenCV to create mini-projects like motion detectors and face recognition tools."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course2Comment1,
                name: "Liam Thompson",
                date: "April 1, 2025",
                rating: 5,
                content: "Fantastic course! It gave me solid foundations in computer vision and the confidence to build my own tools."
            },
            {
                id: 2,
                image: images.course2Comment2,
                name: "Sophia Lee",
                date: "April 3, 2025",
                rating: 4.8,
                content: "The real-time projects were especially helpful. I loved how practical and hands-on the learning experience was."
            }
        ],
    },
    {
        id: 3,
        image: images.course3,
        title: "Deep Learning and Neural Networks",
        content: "Explore how deep neural networks enable machines to learn and solve complex tasks efficiently.",
        details: {
            date: "15 March, 2025",
            duration: "4 Months",
            instructor: "Emily White",
            skillLevel: "Advanced",
            certificate: "Yes",
            students: "120 Enrolled",
            price: "$150",
        },
        overviews: [
            "This course offers an in-depth understanding of deep learning concepts and neural network architectures. Students will explore forward and backward propagation, activation functions, optimization methods, and the implementation of different types of neural networks including CNNs, RNNs, and GANs using TensorFlow and PyTorch."
        ],
        features: [
            "Fundamentals of Deep Learning",
            "Designing and Training Neural Networks",
            "Convolutional Neural Networks (CNNs)",
            "Recurrent Neural Networks (RNNs)",
            "Generative Adversarial Networks (GANs)",
            "Hands-on Deep Learning Projects"
        ],
        outcomes: [
            "Understand how deep neural networks work",
            "Build, train, and optimize neural network models",
            "Apply CNNs to image-related tasks",
            "Use RNNs for sequence and time-series data",
            "Generate new content using GANs",
            "Gain practical experience with TensorFlow and PyTorch"
        ],
        prerequisites: [
            "Proficiency in Python programming",
            "Basic understanding of machine learning",
            "Familiarity with linear algebra and calculus",
            "Prior experience with data structures and algorithms",
            "Willingness to explore mathematical underpinnings of deep learning"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Introduction to Deep Learning",
                content: "Explore the evolution of deep learning and its relevance in AI systems."
            },
            {
                id: 2,
                heading: "Building Neural Networks",
                content: "Learn how to design feedforward neural networks and train them using backpropagation."
            },
            {
                id: 3,
                heading: "Convolutional Neural Networks (CNNs)",
                content: "Understand how CNNs are used in image classification and object detection."
            },
            {
                id: 4,
                heading: "Recurrent Neural Networks (RNNs)",
                content: "Study RNNs for handling sequential data such as language and time-series."
            },
            {
                id: 5,
                heading: "Generative Models and GANs",
                content: "Build GANs to generate synthetic data, images, and more."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course3Comment1,
                name: "Aiden Walker",
                date: "May 10, 2025",
                rating: 5,
                content: "An advanced course that breaks down complex topics really well. Loved the CNN and GAN sections!"
            },
            {
                id: 2,
                image: images.course3Comment2,
                name: "Isabella Martinez",
                date: "May 12, 2025",
                rating: 4.9,
                content: "This course gave me the tools I needed to start working on real-world AI problems. Highly recommend!"
            }
        ],
    },
    {
        id: 4,
        image: images.course4,
        title: "Robotics Enhanced by Artificial Intelligence",
        content: "Discover how AI empowers robots to perform smarter, adaptive, and more precise actions.",
        details: {
            date: "1 April, 2025",
            duration: "3.5 Months",
            instructor: "Michael Brown",
            skillLevel: "Advanced",
            certificate: "Yes",
            students: "95 Enrolled",
            price: "$130",
        },
        overviews: [
            "This course bridges the gap between robotics and artificial intelligence, equipping students with the knowledge to design intelligent robotic systems. Learners will explore how AI techniques such as computer vision, reinforcement learning, and sensor fusion are applied in modern robotics for automation, navigation, and decision-making."
        ],
        features: [
            "Basics of Robotics Systems",
            "Integration of AI in Robotics",
            "Path Planning and Navigation",
            "Sensor Fusion and Environment Mapping",
            "Reinforcement Learning for Robotic Control",
            "Simulation and Real-World Robotics Projects"
        ],
        outcomes: [
            "Understand the core components of robotic systems",
            "Design and program AI-powered robots",
            "Implement path planning and object avoidance",
            "Integrate computer vision into robotic tasks",
            "Apply reinforcement learning for robotic behavior",
            "Build and test robots using simulation tools"
        ],
        prerequisites: [
            "Basic knowledge of robotics or engineering principles",
            "Understanding of AI or machine learning concepts",
            "Familiarity with Python and ROS (Robot Operating System) is a plus",
            "Comfort with math and physics concepts",
            "Curiosity about autonomous and intelligent systems"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Foundations of Robotics",
                content: "Overview of mechanical, electrical, and control systems in robotics."
            },
            {
                id: 2,
                heading: "AI in Robotics",
                content: "Learn how artificial intelligence enhances robotic perception and decision-making."
            },
            {
                id: 3,
                heading: "Path Planning and SLAM",
                content: "Explore simultaneous localization and mapping and autonomous navigation techniques."
            },
            {
                id: 4,
                heading: "Computer Vision and Sensors",
                content: "Integrate visual and environmental sensors for object detection and tracking."
            },
            {
                id: 5,
                heading: "Reinforcement Learning in Robotics",
                content: "Train robots using trial-and-error learning and reward-driven behavior modeling."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course4Comment1,
                name: "Sophie Lee",
                date: "June 2, 2025",
                rating: 5,
                content: "The combination of AI and robotics in this course is perfect for anyone looking to innovate in automation!"
            },
            {
                id: 2,
                image: images.course4Comment2,
                name: "Noah Kim",
                date: "June 3, 2025",
                rating: 4.8,
                content: "Great content and projects. The SLAM and RL modules were very practical and well-explained."
            }
        ],
    },
    {
        id: 5,
        image: images.course5,
        title: "Artificial Intelligence in Autonomous Systems",
        content: "Explore AI technologies driving self-driving vehicles and automated systems for safer, efficient operation.",
        details: {
            date: "15 May, 2025",
            duration: "4 Months",
            instructor: "Jane Smith",
            skillLevel: "Advanced",
            certificate: "Yes",
            students: "110 Enrolled",
            price: "$150",
        },
        overviews: [
            "This course explores how artificial intelligence powers autonomous systems, including self-driving cars, drones, and smart robotics. Students will learn how machine learning, computer vision, and decision-making algorithms are integrated into real-time autonomous behaviors."
        ],
        features: [
            "Introduction to Autonomous Systems",
            "Perception and Environment Modeling",
            "Motion Planning and Control",
            "Deep Learning for Decision-Making",
            "Sensor Fusion and Real-Time Processing",
            "Simulation Projects with Autonomous Agents"
        ],
        outcomes: [
            "Understand how AI enables autonomy in machines",
            "Build perception models using sensor data",
            "Implement path planning and motion control systems",
            "Train deep learning models for decision-making",
            "Simulate and test autonomous agents in realistic environments",
            "Analyze real-world use cases like autonomous vehicles and drones"
        ],
        prerequisites: [
            "Strong understanding of AI or machine learning concepts",
            "Proficiency in Python and basic algorithms",
            "Familiarity with robotics or control systems is a plus",
            "Basic knowledge of physics and geometry",
            "Interest in building intelligent, self-operating systems"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Overview of Autonomous Systems",
                content: "Understand what makes a system autonomous and the key components involved."
            },
            {
                id: 2,
                heading: "AI Techniques for Perception",
                content: "Use deep learning and computer vision to detect and interpret surroundings."
            },
            {
                id: 3,
                heading: "Planning and Control",
                content: "Learn algorithms for motion planning, path optimization, and control."
            },
            {
                id: 4,
                heading: "Sensor Fusion and Localization",
                content: "Combine data from LiDAR, cameras, GPS, and IMUs for accurate localization."
            },
            {
                id: 5,
                heading: "Autonomous System Simulations",
                content: "Design and simulate autonomous behaviors using platforms like CARLA or Gazebo."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course5Comment1,
                name: "David Chen",
                date: "May 20, 2025",
                rating: 5,
                content: "This course was perfect for understanding how AI drives autonomous vehicles. The simulation exercises were amazing."
            },
            {
                id: 2,
                image: images.course5Comment2,
                name: "Lara Mitchell",
                date: "May 22, 2025",
                rating: 4.9,
                content: "Highly recommend this course to anyone interested in robotics or self-driving cars. Very in-depth and practical!"
            }
        ],
    },
    {
        id: 6,
        image: images.course6,
        title: "Artificial Intelligence in Healthcare",
        content: "Learn how AI improves diagnosis, treatment, and patient care with smart healthcare solutions.",
        details: {
            date: "22 May, 2025",
            duration: "3.5 Months",
            instructor: "Emily White",
            skillLevel: "Intermediate",
            certificate: "Yes",
            students: "95 Enrolled",
            price: "$130",
        },
        overviews: [
            "Artificial Intelligence in Healthcare explores the transformative role of AI in diagnostics, treatment planning, patient monitoring, and medical imaging. This course provides hands-on experience with real healthcare datasets and introduces machine learning applications in clinical environments."
        ],
        features: [
            "AI in Medical Diagnostics",
            "Predictive Analytics for Healthcare",
            "Natural Language Processing in EHRs",
            "Medical Image Analysis",
            "Ethical and Regulatory Aspects",
            "Real-World Healthcare AI Case Studies"
        ],
        outcomes: [
            "Understand AI applications in healthcare systems",
            "Use ML algorithms to analyze patient data",
            "Develop AI tools for diagnostics and treatment",
            "Process and interpret medical images using AI",
            "Evaluate ethical and privacy concerns in healthcare AI",
            "Build AI models using actual clinical datasets"
        ],
        prerequisites: [
            "Basic knowledge of AI or data science",
            "Familiarity with Python and data visualization",
            "Interest in healthcare technologies and challenges",
            "Understanding of healthcare workflows is helpful",
            "Willingness to explore data-driven clinical solutions"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Introduction to AI in Healthcare",
                content: "Overview of how AI is revolutionizing healthcare, key areas of impact, and current trends."
            },
            {
                id: 2,
                heading: "Machine Learning for Medical Data",
                content: "Use supervised and unsupervised learning to derive insights from patient records and health metrics."
            },
            {
                id: 3,
                heading: "AI in Medical Imaging",
                content: "Apply computer vision techniques to detect patterns in X-rays, MRIs, and CT scans."
            },
            {
                id: 4,
                heading: "NLP in Clinical Texts",
                content: "Analyze and extract information from electronic health records and physician notes."
            },
            {
                id: 5,
                heading: "Case Studies & Ethics",
                content: "Explore successful case studies and discuss regulatory, ethical, and patient privacy concerns."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course6Comment1,
                name: "Sofia Malik",
                date: "June 1, 2025",
                rating: 5,
                content: "Fantastic course! I gained a strong foundation in applying AI to real medical data and images."
            },
            {
                id: 2,
                image: images.course6Comment2,
                name: "Raj Patel",
                date: "June 3, 2025",
                rating: 4.8,
                content: "Loved the practical projects and insights into ethical AI use in healthcare. Very informative!"
            }
        ],
    }

];

export default courses;